module.exports = {
  id: 34,
  name: 'Mountain Climber Burpees',
  categories: ['cardio', 'strength', 'fullBody'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Power',
  points: 25,
  instructions:
    'Mountain climber burpees are super challenging! Start standing, drop to push-up position, do 3 mountain climbers, then jump back up!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready for the ultimate challenge?',
    },
    {
      time: 3,
      text: "Let's power up and get started!",
    },
    {
      time: 6,
      text: '3, 2, 1, START!',
    },
    // SET 1 - 6 reps
    {
      time: 9,
      text: 'Number 1! Drop down to push-up position, keep your body straight!',
    },
    {
      time: 11,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 13,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 15,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 17,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 19,
      text: 'Number 2! Drop down to push-up position!',
    },
    {
      time: 21,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 23,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 25,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 27,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 29,
      text: 'Number 3! Drop down to push-up position!',
    },
    {
      time: 31,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 33,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 35,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 37,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 39,
      text: 'Number 4! Drop down to push-up position!',
    },
    {
      time: 41,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 43,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 45,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 47,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 49,
      text: 'Number 5! Drop down to push-up position!',
    },
    {
      time: 51,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 53,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 55,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 57,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 59,
      text: 'Number 6! Last one of this set!',
    },
    {
      time: 61,
      text: 'Drop down to push-up position!',
    },
    {
      time: 63,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 65,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 67,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 69,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 71,
      text: 'Incredible power! Take a break.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 74,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 77,
      text: 'Shake out your arms and legs.',
    },
    {
      time: 80,
      text: 'You are building incredible power!',
    },
    {
      time: 83,
      text: 'Ready for round two?',
    },
    {
      time: 86,
      text: '3, 2, 1, START!',
    },
    // SET 2 - 6 reps
    {
      time: 89,
      text: 'Number 1! Drop down to push-up position, keep your body straight!',
    },
    {
      time: 91,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 93,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 95,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 97,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 99,
      text: 'Number 2! Drop down to push-up position!',
    },
    {
      time: 101,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 103,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 105,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 107,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 109,
      text: 'Number 3! Drop down to push-up position!',
    },
    {
      time: 111,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 113,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 115,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 117,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 119,
      text: 'Number 4! Drop down to push-up position!',
    },
    {
      time: 121,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 123,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 125,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 127,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 129,
      text: 'Number 5! Drop down to push-up position!',
    },
    {
      time: 131,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 133,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 135,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 137,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 139,
      text: 'Number 6! Last one of this set!',
    },
    {
      time: 141,
      text: 'Drop down to push-up position!',
    },
    {
      time: 143,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 145,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 147,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 149,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 151,
      text: 'Incredible power! Take another break.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 154,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 157,
      text: 'Shake out your arms and legs.',
    },
    {
      time: 160,
      text: 'You are building incredible power!',
    },
    {
      time: 163,
      text: 'Ready for the final round?',
    },
    {
      time: 166,
      text: '3, 2, 1, START!',
    },
    // SET 3 - 6 reps
    {
      time: 169,
      text: 'Number 1! Drop down to push-up position, keep your body straight!',
    },
    {
      time: 171,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 173,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 175,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 177,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 179,
      text: 'Number 2! Drop down to push-up position!',
    },
    {
      time: 181,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 183,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 185,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 187,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 189,
      text: 'Number 3! Drop down to push-up position!',
    },
    {
      time: 191,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 193,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 195,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 197,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 199,
      text: 'Number 4! Drop down to push-up position!',
    },
    {
      time: 201,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 203,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 205,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 207,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 209,
      text: 'Number 5! Drop down to push-up position!',
    },
    {
      time: 211,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 213,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 215,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 217,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 219,
      text: 'Number 6! Last one ever!',
    },
    {
      time: 221,
      text: 'Drop down to push-up position!',
    },
    {
      time: 223,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 225,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 227,
      text: 'Drive your right knee toward your chest again!',
    },
    {
      time: 229,
      text: 'Explode up and jump as high as you can!',
    },
    {
      time: 231,
      text: 'Incredible work! You are done!',
    },
    // COMPLETION
    {
      time: 234,
      text: 'Amazing work! You just did 18 mountain climber burpees!',
    },
    {
      time: 237,
      text: 'You are building incredible power and endurance!',
    },
    {
      time: 240,
      text: 'Great job, power champion!',
    },
  ],
};
